export const recommendationsTableAccessors = {
  expectedRecommended: 'expected_recommended',
  recommendation: 'recommendation',
  signalType: 'signal_type',
};
